import type { CanvasArtwork } from "../data/canvasArtworks";

export function isCanvasAvailable(work: CanvasArtwork): boolean {
  return work.available !== false;
}

export function isCanvasSold(work: CanvasArtwork): boolean {
  return !isCanvasAvailable(work);
}
